import { faGameConsoleHandheld } from "@fortawesome/pro-regular-svg-icons";

class AppVersion {
    constructor() {
        this.newVersion = document.getElementById("js-mix-version").attributes.content.value
        this.oldVersion = localStorage.getItem("mixVersion")
    }

    isDifferentVersion() {
        return this.oldVersion == null || this.newVersion != this.oldVersion
    }

    cleanUpCache() {
        if (this.isDifferentVersion()) {
            localStorage.removeItem("locale") // Kill the locale in the local storage

            const cookies = document.cookie.split(";");
            for (var c = 0; c < cookies.length; c++) {
                // Overwrite only relevant existing cookies and set a expiration date in the past
                if(cookies[c].includes("locale=")) {
                    document.cookie = cookies[c] + "; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                }
            }

            // Write new version to local storage
            localStorage.setItem("mixVersion", this.newVersion)
        }
    }
}

export { AppVersion }